import * as React from "react";
import { useState, useEffect } from "react";
import { fetchOptions } from "../api";
import { useSearchParams, useNavigate } from "react-router-dom";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import Stack from "@mui/joy/Stack";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import Autocomplete from "@mui/joy/Autocomplete";
import states from "../data/states.json";
import cities from "../data/state_cities.json";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import Grid from "@mui/joy/Grid";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

import CircularProgress from '@mui/joy/CircularProgress';
import { TagRounded, CurrencyRupeeRounded } from "@mui/icons-material";

import Sidebar from "../components/common/Sidebar";
import Header from "../components/common/Header";
import JoyDatePicker from "../components/common/JoyDatePicker";
import PageBreadcrumbs from "../components/common/PageBreadcrumbs";


export default function EditDonation() {
   const [loading, setLoading] = useState(true);

   let Navigate = useNavigate();


   const [errors, setErrors] = useState({
      name: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      pan: "",
   });

   const [donationData, setDonationData] = useState({
      id: "",
      donorId: "",
      name: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      country: "India",
      pincode: "",
      pan: "",
      email: "",
      donorType: "individual",
      date: "",
      amount: "",
      paymentMethod: "",
      gift: "",
      purpose: "",
      event: "",
      taxReceiptNo: "",
      head: "",
      status: "",
      note: "",
      txnRefId: "",
      refBy: null,
      subPurpose: "",
   });

   const [errorsD, setErrorsD] = useState({
      amount: "",
      date: "",
      paymentMethod: "",
      purpose: "",
      event: "",
   });
   const [isSubmittingD, setIsSubmittingD] = useState(false);
   const [messageD, setMessageD] = useState<string | null>(null);
   const [errorD, setErrorD] = useState<string | null>(null);

   const [options, setOptions] = useState({
      Purpose: [],
      Event: [],
      Head: [],
      Gift: [],
   });

   const [searchParams] = useSearchParams();
   const donationId = searchParams.get("id");

   const [showDonorForm, setShowDonorForm] = useState(false);

   useEffect(() => {
      const fetchDonation = async () => {
         if (!donationId) return;

         setLoading(true);
         try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/donation/${donationId}`, {
               method: "GET",
               headers: { "Content-Type": "application/json" },
               credentials: "include",
            });

            if (!response.ok) {
               if (response.status === 401) {
                  const redirectUrl = encodeURIComponent(window.location.href);
                  window.location.href = `${process.env.REACT_APP_AUTH_WEB_URL}/signin?redirect=${redirectUrl}`;
                  return;
               }
               throw new Error("Failed to fetch donation details.");
            }

            const data = await response.json();

            setDonationData({
               id: data.id,
               donorId: data.donorId?.toString() || "",
               name: data.name || "",
               phone: data.phone || "",
               address: data.address || "",
               city: data.city || "",
               state: data.state || "",
               country: data.country || "India",
               pincode: data.pincode || "",
               pan: data.pan || "",
               email: data.email || "",
               donorType: data.donorType || "individual",
               date: data.date || "",
               amount: data.amount ? data.amount.toString() : "",
               paymentMethod: data.paymentMethod || "",
               gift: data.gift || "",
               purpose: data.purpose || "",
               event: data.event || "",
               taxReceiptNo: data.taxReceiptNo || "",
               head: data.head || "",
               status: data.status || "",
               note: data.note || "",
               txnRefId: data.txnRefId || "",
               refBy: data.refBy || null,
               subPurpose: data.subPurpose || "",
            });
            setShowDonorForm(true);
         } catch (error) {
            console.error("Error fetching donation:", error);
         } finally {
            setLoading(false);
         }
      };

      fetchDonation();
   }, [donationId]);

   useEffect(() => {
      const loadOptions = async () => {
         const categories = ["Purpose", "Event", "Head", "Gift"];
         try {
            const results = await Promise.all(categories.map((c) => fetchOptions(c)));
            const data: any = {};
            categories.forEach((cat, idx) => {
               data[cat] = results[idx];
            });
            setOptions(data);
         } catch (error) {
            console.error("Failed to fetch donation options:", error);
         }
      };

      loadOptions();
   }, []);


   const handleSelectChange = (event: any, newValue: string | null, field: string) => {
      setDonationData((prev) => ({ ...prev, [field]: newValue || "" }));
   };

   const handleDonorInputChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
   ) => {
      const { name, value } = e.target;
      let errorMsg = "";
      let validatedValue = value;

      switch (name) {
         case "phone":
            if (!/^[1-9][0-9]{9}$/.test(value)) {
               errorMsg = "Must be exactly 10 digits and cannot start with 0.";
            }
            validatedValue = value.slice(0, 10);
            break;
         case "email":
            if (value && !/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(value)) {
               errorMsg = "Enter a valid email address.";
            }
            break;
         case "address":
            if (!/^[a-zA-Z0-9 ,\-\/]*$/.test(value) || value.length > 100) {
               errorMsg = "Max 100 characters. Only letters, numbers, ',', '-', and '/' allowed.";
            }
            validatedValue = value.slice(0, 100);
            break;
         case "city":
            validatedValue = value.toUpperCase();
            if (!/^[A-Z ]*$/.test(validatedValue) || validatedValue.length > 20) {
               errorMsg = "Max 20 characters. Only uppercase letters and spaces allowed.";
            }
            validatedValue = validatedValue.slice(0, 20);
            break;
         case "pincode":
            if (!/^[0-9]{0,6}$/.test(value)) {
               errorMsg = "Must be exactly 6 digits.";
            }
            validatedValue = value.slice(0, 6);
            break;
         case "pan":
            validatedValue = value.toUpperCase();
            if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(validatedValue)) {
               errorMsg = "PAN must be exactly 10 characters: 5 letters, 4 digits, 1 letter.";
            }
            validatedValue = validatedValue.slice(0, 10);
            break;
         default:
            break;
      }

      setErrors((prev) => ({ ...prev, [name]: errorMsg }));
      setDonationData((prev) => ({ ...prev, [name]: validatedValue }));
   };

   const handleCityInputChange = (_event: React.SyntheticEvent, newInputValue: string) => {
      let errorMsg = "";
      if (newInputValue.length > 20 || !/^[A-Z ]*$/.test(newInputValue.toUpperCase())) {
         errorMsg = "Max 20 characters. Only uppercase letters and spaces allowed.";
      }
      setErrors((prev) => ({ ...prev, city: errorMsg }));
      setDonationData((prev) => ({ ...prev, city: newInputValue }));
   };

   const handleDonationInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      let errorMsg = "";
      let validatedValue = value;

      switch (name) {
         case "amount":
            if (!/^\d*\.?\d*$/.test(value)) {
               return; // Prevent invalid character entry
            }
            if (value && parseFloat(value) < 0) {
               errorMsg = "Enter a valid positive amount.";
            }
            break;

         case "taxReceiptNo":
            if (!/^\d*$/.test(value)) {
               return; // Prevent non-numeric character entry
            }
            break;
         case "date":
            if (!value) {
               errorMsg = "Date is required.";
            }
            break;

         default:
            break;
      }

      setErrorsD((prev) => ({ ...prev, [name]: errorMsg }));
      setDonationData((prev) => ({ ...prev, [name]: validatedValue }));
   };

   const handleSaveDonation = async () => {
      setIsSubmittingD(true);
      setMessageD("");
      setErrorD(null);

      if (!donationData.amount || !donationData.date || !donationData.paymentMethod) {
         setErrorD("Please fill in all required fields.");
         setIsSubmittingD(false);
         return;
      }

      // Convert amount to a float number
      const formattedAmount = parseFloat(donationData.amount);
      if (isNaN(formattedAmount) || formattedAmount <= 0) {
         setErrorD("Enter a valid positive amount.");
         setIsSubmittingD(false);
         return;
      }

      // Convert date to IST (Indian Standard Time) format
      const formattedDate = dayjs(donationData.date).tz("Asia/Kolkata").format("YYYY-MM-DDTHH:mm:ssZ");

      const formattedDonation = {
         ...donationData,
         amount: formattedAmount, // Convert amount to float
         date: formattedDate, // Ensure correct format with IST
         donorId: Number(donationData.donorId),
      };

      try {
         const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/donation/${donationData.id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formattedDonation),
            credentials: "include",
         });

         if (!response.ok) {
            if (response.status === 401) {
               const redirectUrl = encodeURIComponent(window.location.href);
               window.location.href = `${process.env.REACT_APP_AUTH_WEB_URL}/signin?redirect=${redirectUrl}`;
               return;
            }
            throw new Error("Failed to update donation.");
         }

         setMessageD("Donation details updated successfully!");
         setShowDonorForm(false);
         setDonationData({
            id: "",
            donorId: "",
            name: "",
            phone: "",
            address: "",
            city: "",
            state: "",
            country: "India",
            pincode: "",
            pan: "",
            email: "",
            donorType: "individual",
            date: "",
            amount: "",
            paymentMethod: "",
            gift: "",
            purpose: "",
            event: "",
            taxReceiptNo: "",
            head: "",
            status: "",
            note: "",
            txnRefId: "",
            refBy: null,
            subPurpose: "",
         });
      } catch (err) {
         setErrorD("Error saving donation. Please try again.");
      } finally {
         setIsSubmittingD(false);
      }
   };

   return (
      <Box sx={{ display: "flex", minHeight: "100dvh" }}>
         <Header />
         <Sidebar />
         <Box
            component="main"
            className="MainContent"
            sx={{
               pt: { xs: "calc(12px + var(--Header-height))", md: 3 },
               pb: { xs: 2, sm: 2, md: 3 },
               flex: 1,
               display: "flex",
               flexDirection: "column",
               minWidth: 0,
               gap: 1,
               overflow: "auto",
               bgcolor: "background.body",
            }}
         >
            <Box sx={{ flex: 1, width: "100%" }}>
               <Box
                  sx={{
                     position: "sticky",
                     top: { sm: -100, md: -110 },
                     bgcolor: "background.body",
                     zIndex: 9995,
                  }}
               >
                  <Box sx={{ px: { xs: 2, md: 6 } }}>
                     <PageBreadcrumbs
                        links={[
                           { label: "Donation", href: "/donation" },
                           { label: `ID - ${donationId}`, href: `/donation/details?id=${donationId}` },
                        ]}
                        current="Edit"
                     />
                     <Typography level="h2" component="h1" sx={{ mt: 1, mb: 2 }}>
                        Edit Donation
                     </Typography>
                  </Box>
               </Box>
               <Stack
                  spacing={4}
                  sx={{
                     display: "flex",
                     maxWidth: "800px",
                     mx: "auto",
                     px: { xs: 2, md: 6 },
                     py: { xs: 2, md: 3 },
                  }}
               >
                  <Card>
                     <Box sx={{ mb: 1 }}>
                        <Typography level="title-md">Edit Donation Details</Typography>
                        <Typography level="body-sm">
                           Edit donor and donation details here.
                        </Typography>
                        {(loading || !showDonorForm) ? (
                           null
                        ) : (
                           <Stack direction="row" spacing={2} sx={{ width: 300, mt: 2, alignItems: "flex-end" }}>

                           </Stack>
                        )}

                     </Box>
                     {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', py: 10 }}>
                           <CircularProgress size="md" />
                        </Box>
                     ) : (
                        <Box>
                           {/* Doner Profile */}
                           {(showDonorForm || donationData.donorId) ? (
                              <Grid container spacing={2} sx={{ flexGrow: 1, mb: 2 }}>
                                 <Grid xs={12} sm={1}>
                                    <FormControl sx={{ flexGrow: 2 }}>
                                       <FormLabel >ID</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="ID"
                                          name="id"
                                          value={donationData.id}
                                          readOnly
                                       />
                                       {errors.name && <FormHelperText>{errors.name}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={4}>
                                    <FormControl sx={{ flexGrow: 2 }} error={!!errors.name}>
                                       <FormLabel >Name</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="Full name"
                                          name="name"
                                          value={donationData.name}
                                          readOnly
                                       />
                                       {errors.name && <FormHelperText>{errors.name}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={3}>
                                    <FormControl sx={{ flexGrow: 1 }} error={!!errors.phone}>
                                       <FormLabel>Phone</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="e.g., 1234567890"
                                          name="phone"
                                          value={donationData.phone}
                                          onChange={handleDonorInputChange}
                                       />
                                       {errors.phone && <FormHelperText>{errors.phone}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={4}>
                                    <FormControl sx={{ flexGrow: 1 }} error={!!errors.email}>
                                       <FormLabel>Email</FormLabel>
                                       <Input
                                          size="sm"
                                          type="email"
                                          placeholder="username@example.com"
                                          name="email"
                                          value={donationData.email}
                                          onChange={handleDonorInputChange}
                                       />
                                       {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={8}>
                                    <FormControl sx={{ flexGrow: 1 }} error={!!errors.address}>
                                       <FormLabel>Address</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="e.g., 62/72 Street, Area"
                                          name="address"
                                          value={donationData.address}
                                          onChange={handleDonorInputChange}
                                       />
                                       {errors.address && <FormHelperText>{errors.address}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={4}>
                                    <FormControl>
                                       <FormLabel>State</FormLabel>
                                       <Select
                                          size="sm"
                                          placeholder="Select"
                                          value={donationData.state}
                                          onChange={(event, newValue) => handleSelectChange(event, newValue, "state")}
                                       >
                                          {states.map((state) => (
                                             <Option key={state} value={state}>{state}</Option>
                                          ))}
                                       </Select>
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.city}>
                                       <FormLabel>City</FormLabel>
                                       <Autocomplete
                                          size="sm"
                                          freeSolo
                                          placeholder="City"
                                          value={donationData.city}
                                          options={
                                             Array.from(new Set(
                                                donationData.state && cities[donationData.state as keyof typeof cities]
                                                   ? cities[donationData.state as keyof typeof cities]
                                                   : Object.values(cities).flat()
                                             ))
                                          }
                                          onInputChange={handleCityInputChange}
                                          getOptionLabel={(option: string) =>
                                             typeof option === "string" ? option : ""
                                          }
                                       />
                                       {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={2}>
                                    <FormControl error={!!errors.pincode}>
                                       <FormLabel>Pincode</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="e.g., 000000"
                                          name="pincode"
                                          value={donationData.pincode}
                                          onChange={handleDonorInputChange}
                                       />
                                       {errors.pincode && <FormHelperText>{errors.pincode}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={3}>
                                    <FormControl error={!!errors.pan}>
                                       <FormLabel>PAN</FormLabel>
                                       <Input
                                          size="sm"
                                          placeholder="ABCDE1234F"
                                          name="pan"
                                          value={donationData.pan}
                                          onChange={handleDonorInputChange}
                                       />
                                       {errors.pan && <FormHelperText>{errors.pan}</FormHelperText>}
                                    </FormControl>
                                 </Grid>
                                 <Grid xs={12} sm={3}>
                                    <FormControl sx={{ flexGrow: 1 }}>
                                       <FormLabel>Type</FormLabel>
                                       <Select
                                          size="sm"
                                          placeholder="Select"
                                          value={donationData.donorType}
                                          onChange={(event, newValue) => handleSelectChange(event, newValue, "donorType")}
                                       >
                                          <Option value="individual">Individual</Option>
                                          <Option value="corporate">Corporate</Option>
                                          <Option value="nonprofit">Non Profit</Option>
                                          <Option value="other">Other</Option>
                                       </Select>
                                    </FormControl>
                                 </Grid>
                              </Grid>
                           ) : (
                              null
                           )}

                           {/* Show Donation Details only if donor ID is present */}
                           {donationData.id && (
                              <Box>
                                 <Divider />
                                 <Grid container spacing={2} sx={{ flexGrow: 1, my: 2 }}>
                                    <Grid xs={12} sm={4}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Amount <Typography component="span" color="danger">*</Typography></FormLabel>
                                          <Input
                                             size="sm"
                                             name="amount"
                                             value={donationData.amount}
                                             startDecorator={<CurrencyRupeeRounded />}
                                             placeholder="e.g., 1,000"
                                             onChange={handleDonationInputChange}
                                          />
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Payment Method <Typography component="span" color="danger">*</Typography></FormLabel>
                                          <Select
                                             size="sm"
                                             placeholder="Select"
                                             value={donationData.paymentMethod}
                                             onChange={(event, newValue) => handleSelectChange(event, newValue, "paymentMethod")}
                                          >
                                             <Option value="Cash">Cash</Option>
                                             <Option value="Cheque">Cheque</Option>
                                             <Option value="Online">Online</Option>
                                          </Select>
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                       <FormControl error={!!errorsD.date}>
                                          <FormLabel>Date <Typography component="span" color="danger">*</Typography></FormLabel>
                                          <JoyDatePicker
                                             name="date"
                                             value={donationData.date ? dayjs(donationData.date) : null}
                                             onChange={(newValue) => {
                                                const formattedDate = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                setDonationData((prev) => ({ ...prev, date: formattedDate }));
                                                setErrorsD((prev) => ({ ...prev, date: formattedDate ? "" : "Date is required." }));
                                             }}
                                             format="YYYY-MM-DD"
                                             slotProps={{
                                                textField: {
                                                   size: "small",
                                                   sx: { height: "32px", minHeight: "32px", fontSize: "0.875rem", padding: "5px 10px" }, // Ensures consistent height
                                                },
                                             }}
                                             sx={{ height: "32px", minHeight: "32px", "& .MuiInputBase-root": { height: "32px" } }}
                                          />
                                          {errorsD.date && <FormHelperText>{errorsD.date}</FormHelperText>}
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Purpose</FormLabel>
                                          <Select
                                             size="sm"
                                             placeholder="Select"
                                             value={donationData.purpose}
                                             onChange={(event, newValue) => handleSelectChange(event, newValue, "purpose")}
                                          >
                                             {options.Purpose.map((opt: any) => (
                                                <Option key={opt.id} value={opt.value}>{opt.value}</Option>
                                             ))}
                                          </Select>
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Event</FormLabel>
                                          <Select
                                             size="sm"
                                             placeholder="Select"
                                             value={donationData.event}
                                             onChange={(event, newValue) => handleSelectChange(event, newValue, "event")}
                                          >
                                             {options.Event.map((opt: any) => (
                                                <Option key={opt.id} value={opt.value}>{opt.value}</Option>
                                             ))}
                                          </Select>
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Tax Receipt No.</FormLabel>
                                          <Input
                                             size="sm"
                                             name="taxReceiptNo"
                                             startDecorator={<TagRounded />}
                                             value={donationData.taxReceiptNo}
                                             placeholder="e.g., 2025068"
                                             onChange={handleDonationInputChange}
                                          />
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Gift</FormLabel>
                                          <Select
                                             size="sm"
                                             placeholder="Select"
                                             value={donationData.gift}
                                             onChange={(event, newValue) => handleSelectChange(event, newValue, "gift")}
                                          >
                                             {options.Gift.map((opt: any) => (
                                                <Option key={opt.id} value={opt.value}>{opt.value}</Option>
                                             ))}
                                          </Select>
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                       <FormControl sx={{ flexGrow: 1 }}>
                                          <FormLabel>Head</FormLabel>
                                          <Select
                                             size="sm"
                                             placeholder="Select"
                                             defaultValue="DMP"
                                             value={donationData.head}
                                             onChange={(event, newValue) => handleSelectChange(event, newValue, "head")}
                                          >
                                             {options.Head.map((opt: any) => (
                                                <Option key={opt.id} value={opt.value}>{opt.value}</Option>
                                             ))}
                                          </Select>
                                       </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={12}>
                                       <FormControl sx={{ display: { sm: "contents" } }}>
                                          <FormLabel>Note</FormLabel>
                                          <Textarea
                                             size="sm"
                                             minRows={2}
                                             name="note"
                                             value={donationData.note}
                                             sx={{ mt: 1.5 }}
                                             placeholder="Add a note"
                                             onChange={handleDonationInputChange}
                                          />
                                       </FormControl>
                                    </Grid>
                                 </Grid>
                                 {messageD && <Typography level="body-sm" sx={{ color: "green", mt: 1 }}>{messageD}</Typography>}
                                 {errorD && <Typography level="body-sm" sx={{ color: "red", mt: 1 }}>{errorD}</Typography>}
                                 <CardOverflow
                                    sx={{ borderTop: "1px solid", borderColor: "divider" }}
                                 >
                                    <CardActions sx={{ alignSelf: "flex-end", pt: 2 }}>
                                       <Button
                                          size="sm"
                                          variant="outlined"
                                          color="neutral"
                                          onClick={() => Navigate(`/donation/details?id=${donationId}`)}
                                       >
                                          Cancel
                                       </Button>
                                       <Button
                                          size="sm"
                                          variant="solid"
                                          onClick={handleSaveDonation}
                                          disabled={
                                             isSubmittingD ||
                                             Object.values(errorsD).some((error) => error !== "") ||
                                             Object.values(errors).some((e) => e !== "")
                                          }
                                       >
                                          {isSubmittingD ? "Updating..." : "Update"}
                                       </Button>
                                    </CardActions>
                                 </CardOverflow>
                              </Box>
                           )}
                           {messageD && !donationData.donorId && (
                              <Box sx={{ mt: 2, textAlign: "center" }}>
                                 <Typography level="body-sm" sx={{ color: "green", mb: 2 }}>
                                    {messageD}
                                 </Typography>
                                 <Button
                                    size="sm"
                                    variant="solid"
                                    sx={{ my: 5 }}
                                    onClick={() => {
                                       Navigate("/donation");
                                    }}
                                 >
                                    All Records
                                 </Button>
                              </Box>
                           )}
                        </Box>
                     )}
                  </Card>
               </Stack>
            </Box>
         </Box>
      </Box>
   );
}

